import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomizerService } from 'src/app/shared/services/customizer.service';
import { NavService } from 'src/app/shared/services/nav.service';
import { AuthenticationClient, LoginRequest, LoginResponse } from 'src/app/shared/api-connector/sso-connector';
import { SignalRHubService } from 'src/app/shared/services/signalr-hub.service';

import { environment } from 'src/environments/environment';

declare var grecaptcha: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public newUser = false;
  public loginForm = new FormGroup({
    usernameCtrl: new FormControl('', [Validators.required]),
    passwordCtrl: new FormControl('', [Validators.required])
  });

  constructor(
    private alertService: AlertService,
    private authService: AuthService,
    private authenticationClient: AuthenticationClient,
    private spinner: NgxSpinnerService,
    public customize: CustomizerService,
    private signalrService: SignalRHubService,
    private navService: NavService,
  ) {
    if (authService.alreadyLogin()) {
      authService.routingDashboard();
    }
  }

  ngOnInit() {
  }

  onLogin() {
    if (this.loginForm.valid) {
      if (typeof grecaptcha === 'undefined') {
        this.alertService.error('Hệ thống bảo mật (reCAPTCHA) chưa sẵn sàng. Vui lòng tải lại trang.', 'Lỗi hệ thống');
        return;
      }

      this.spinner.show();
      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise.execute(environment.capchaSecret, { action: 'login' }).then((token: string) => {
          this.executeLogin(token);
        }).catch(err => {
          console.error('reCAPTCHA Error:', err);
          this.spinner.hide();
          this.alertService.error('Không thể xác thực bảo mật. Vui lòng thử lại hoặc kiểm tra kết nối mạng.');
        });
      });
    }
  }

  executeLogin(captchaToken: string) {
    const firebaseToken = this.authService.getFirebaseToken();
    this.authenticationClient.login(new LoginRequest({
      password: this.loginForm.controls.passwordCtrl.value,
      username: this.loginForm.controls.usernameCtrl.value,
      deviceId: this.signalrService.getOrCreateDeviceId(),
      firebaseToken,
      osPlatform: 'web',
      osVersion: 'v1',
      captchaToken: captchaToken
    }))
      .pipe(
        finalize(() => {
          this.spinner.hide();
        }
        ))
      .subscribe(
        (data: LoginResponse) => {
          this.handlingLogin(data);
        }
      );
  }
  handlingLogin(data: LoginResponse) {
    if (data.isSuccess) {
      this.authService.setToken(data.token);
      this.authService.setRefreshToken(data.refreshToken);
      this.signalrService.startConnection();
      if (this.authService.getAccount().laNhanVien) {
        this.authService.routingDashboard();
      } else {
        this.authService.routingOrder();
      }

      this.navService.getMenusForCMS();
    } else {
      this.alertService.error(data.message, 'Đăng nhập hệ thống thất bại');
    }
  }

}
